import React from 'react';

const Info = (props: React.SVGProps<SVGSVGElement>) => {
  const { color = '#BB5A00' } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_4732_61533"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4732_61533)">
        <path
          d="M9.45897 13.792H10.543V8.99999H9.45897V13.792ZM10.001 7.74999C10.1676 7.74999 10.3066 7.69099 10.418 7.57299C10.5286 7.45499 10.584 7.31266 10.584 7.14599C10.584 6.99333 10.5286 6.85799 10.418 6.73999C10.3066 6.62133 10.1676 6.56199 10.001 6.56199C9.8343 6.56199 9.6953 6.61766 9.58397 6.72899C9.4733 6.84033 9.41797 6.97933 9.41797 7.14599C9.41797 7.31266 9.4733 7.45499 9.58397 7.57299C9.6953 7.69099 9.8343 7.74999 10.001 7.74999ZM10.001 17.583C8.95964 17.583 7.97697 17.3853 7.05297 16.99C6.12964 16.594 5.32397 16.0523 4.63597 15.365C3.94864 14.677 3.40697 13.8713 3.01097 12.948C2.61564 12.024 2.41797 11.0413 2.41797 9.99999C2.41797 8.94466 2.61564 7.95866 3.01097 7.04199C3.40697 6.12533 3.94864 5.32299 4.63597 4.63499C5.32397 3.94766 6.12964 3.40599 7.05297 3.00999C7.97697 2.61466 8.95964 2.41699 10.001 2.41699C11.0563 2.41699 12.0423 2.61466 12.959 3.00999C13.8756 3.40599 14.678 3.94766 15.366 4.63499C16.0533 5.32299 16.595 6.12866 16.991 7.05199C17.3863 7.97599 17.584 8.95866 17.584 9.99999C17.584 11.0413 17.3863 12.024 16.991 12.948C16.595 13.8713 16.0533 14.677 15.366 15.365C14.678 16.0523 13.8723 16.594 12.949 16.99C12.025 17.3853 11.0423 17.583 10.001 17.583ZM10.001 16.5C11.8063 16.5 13.341 15.868 14.605 14.604C15.869 13.34 16.501 11.8053 16.501 9.99999C16.501 8.19466 15.869 6.65999 14.605 5.39599C13.341 4.13199 11.8063 3.49999 10.001 3.49999C8.19564 3.49999 6.66097 4.13199 5.39697 5.39599C4.13297 6.65999 3.50097 8.19466 3.50097 9.99999C3.50097 11.8053 4.13297 13.34 5.39697 14.604C6.66097 15.868 8.19564 16.5 10.001 16.5Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default Info;
